import React from "react";
import EnginesMatrix from "@/components/EnginesMatrix";
import PageCTA from "@/components/PageCTA";

const EnginesPage = () => (
  <div className="pt-24">
    <EnginesMatrix />
    <PageCTA
      heading="Which engine fits your business?"
      sub="Answer four short questions and we'll match you to the right engine + a preliminary friction score — on the spot."
      secondary={{ to: "/demo", label: "See the Flow Engine Live" }}
    />
  </div>
);

export default EnginesPage;
